import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useNavigate } from '@/hooks/use-navigate';
import { buildSearchAfterFiltersToggle, getInitialFiltersOpen } from '@/lib/plp-panel-url-state';

export {
    ACTION_PARAMS,
    FILTERS_CLOSED,
    FILTERS_OPEN,
    FILTERS_QUERY_PARAM,
    getInitialFiltersOpen,
    getSearchWithoutActionParams,
    getSearchWithoutClientOnlyParams,
    getSearchWithoutFiltersParam,
    getSearchWithoutPlpPanelUiParams,
    isSamePathnameListingDataNavigationPending,
} from '@/lib/plp-panel-url-state';

export function useFiltersPanelState(initialFiltersOpen?: boolean) {
    const location = useLocation();
    const navigate = useNavigate();
    const [filtersOpen, setFiltersOpen] = useState(Boolean(initialFiltersOpen));

    useEffect(() => {
        const nextFiltersOpen = getInitialFiltersOpen(new URLSearchParams(location.search));
        setFiltersOpen(nextFiltersOpen);
    }, [location.search]);

    const toggleFiltersOpen = useCallback(() => {
        const nextFiltersOpen = !filtersOpen;
        setFiltersOpen(nextFiltersOpen);
        void navigate(
            {
                pathname: location.pathname,
                search: buildSearchAfterFiltersToggle(location.search, nextFiltersOpen),
            },
            { replace: true, preventScrollReset: true }
        );
    }, [filtersOpen, location.pathname, location.search, navigate]);

    const handleFiltersDrawerOpenChange = useCallback(
        (nextOpen: boolean) => {
            if (nextOpen === filtersOpen) {
                return;
            }
            toggleFiltersOpen();
        },
        [filtersOpen, toggleFiltersOpen]
    );

    return { filtersOpen, toggleFiltersOpen, handleFiltersDrawerOpenChange };
}
